"use client"

import { FileText, Search, X } from "lucide-react"
import { cn } from "@/lib/utils"

interface EmptyBlogStateProps {
  hasFilters?: boolean
  onClearFilters?: () => void
  className?: string
}

export function EmptyBlogState({
  hasFilters = false,
  onClearFilters,
  className,
}: EmptyBlogStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-12 sm:py-16 text-center",
        className
      )}
    >
      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-bg-alt border border-border flex items-center justify-center mb-4 sm:mb-6">
        {hasFilters ? (
          <Search className="w-7 h-7 sm:w-8 sm:h-8 text-text-muted" />
        ) : (
          <FileText className="w-7 h-7 sm:w-8 sm:h-8 text-text-muted" />
        )}
      </div>

      <h3 className="text-lg sm:text-xl font-bold text-text mb-2">
        {hasFilters ? "No posts match your search" : "No blog posts yet"}
      </h3>

      <p className="text-sm sm:text-base text-text-muted max-w-md mb-4 sm:mb-6 px-4">
        {hasFilters
          ? "Try adjusting your search query or clearing the filters to see all posts."
          : "Check back soon for new articles about AI solutions, infrastructure, and cloud development."}
      </p>

      {hasFilters && onClearFilters && (
        <button
          onClick={onClearFilters}
          className={cn(
            "inline-flex items-center gap-2 px-4 py-2 rounded-lg",
            "bg-white border border-border hover:border-primary",
            "text-text-secondary hover:text-primary text-sm font-medium",
            "transition-colors duration-200"
          )}
        >
          <X className="w-4 h-4" />
          Clear filters
        </button>
      )}
    </div>
  )
}
